import React, { useState } from "react";
import Logger from "../../../services/Logger";
import {
    Alert,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Grid,
    Typography
} from "@mui/material";
import Item from "../../components/Item";
import IngestService from "./IngestService";
import ConfirmDialog from "../../components/ConfirmDialog";

const AgentGoogleBook = ({ setting, onRefresh }) => {
    const [googleBookProcessing, setGoogleBookProcessing] = useState(false);
    const [googleBookError, setGoogleBookError] = useState(null);
    const [googleBookSuccess, setGoogleBookSuccess] = useState(null);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const handleGoogleBookProcessKidsBooks = () => {
        setShowConfirmDialog(true);
    };

    const confirmGoogleBookProcessBooks = async () => {
        try {
            setGoogleBookProcessing(true);
            setGoogleBookError(null);
            setGoogleBookSuccess(null);

            const result = await IngestService.processGoogleBook();
            
            if (result.success) {
                setGoogleBookSuccess("Google Books kids books have been processed successfully");
                
                // Refresh all settings after ingest
                if (onRefresh) {
                    await onRefresh();
                }
            } else {
                setGoogleBookError(result.error);
            }
        } catch (err) {
            Logger.error("Error processing Google Books kids books:", err);
            setGoogleBookError(err.message || "Failed to process Google Books kids books");
        } finally {
            setGoogleBookProcessing(false);
        }
    };

    return (
        <Item sx={{ height: '100%', width: '100%' }}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                        Google Books
                    </Typography>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                        {setting && (
                            <Grid size="auto">
                                <Typography variant="body1" color="text.secondary">
                                    Last processed start index:
                                </Typography>
                                <Typography variant="h6" sx={{ mt: 1 }}>
                                    {setting.value}
                                </Typography>
                            </Grid>
                        )}
                        <Grid size="auto">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleGoogleBookProcessKidsBooks}
                                disabled={googleBookProcessing}
                                sx={{ minWidth: 140 }}
                            >
                                {googleBookProcessing ? (
                                    <>
                                        <CircularProgress size={20} sx={{ mr: 1 }} />
                                        Processing...
                                    </>
                                ) : (
                                    "Execute"
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                    {googleBookSuccess && (
                        <Alert severity="success" sx={{ mt: 2 }}>
                            {googleBookSuccess}
                        </Alert>
                    )}
                    {googleBookError && (
                        <Alert severity="error" sx={{ mt: 2 }}>
                            {googleBookError}
                        </Alert>
                    )}
                    <Alert severity="info" sx={{ mt: 2 }}>
                        Process Google Books books to create puzzles. The system stores the last processed start index for pagination.
                    </Alert>
                </CardContent>
            </Card>

            <ConfirmDialog
                open={showConfirmDialog}
                setOpen={setShowConfirmDialog}
                title="Confirm Process Google Books"
                message="Are you sure you want to process Google Books? This may take a while."
                callback={confirmGoogleBookProcessBooks}
            />
        </Item>
    );
};

export default AgentGoogleBook;
